import { defineAction } from '~/prix'
import { z } from 'zod'
import collectionIncentiveDeliveryReceiptAction from './collectionIncentiveDeliveryReceipt.action.json' with { type: 'json' }

const collectionIncentiveDeliveryReceiptDefinition = defineAction({
  ...collectionIncentiveDeliveryReceiptAction,

  input: z.object({
    collectionIncentiveId: z.string().uuid(),
    format: z.literal('pdf').default('pdf'),
  }),
  output: z.any(),
})

export default collectionIncentiveDeliveryReceiptDefinition
